module.exports = fox => {
	'use strict';

	class PushNotificationsManager {
		checkBrowser() {
			return fox.Promise.resolve({state: !!('Notification' in window)});
		}

		requestPermission() {
			return Notification.requestPermission();
		}

		getPermission() {
			return Notification.permission;
		}

		isDefaultPermission() {
			return this.getPermission() === 'default';
		}

		isGrantedPermission() {
			return this.getPermission() === 'granted';
		}

		isDeniedPermission() {
			return this.getPermission() === 'denied';
		}
	}

	return new PushNotificationsManager();
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/push-notifications/manager.es.js